import { DECK, SKILL_IDS, SKILL_PICK, TOTEM_KINDS, validDeck, type Kind, type SkillId, type TotemKind } from '@orb/sim';

/**
 * What the lobby picked for the next battle: the deck (four elements; the prism comes anyway), the one
 * active skill and the totem to start with. Kept on the device; sent as the match's first actions
 * (set_deck, equip_skill, equip_totem) when the battle begins.
 */
export interface Loadout { deck: Kind[]; skill: SkillId; totem: TotemKind }
const KEY = 'orb.loadout';

export function loadout(): Loadout {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    if (v && SKILL_IDS.includes(v.skill) && TOTEM_KINDS.includes(v.totem)) return { deck: Array.isArray(v.deck) && validDeck(v.deck) ? v.deck : [...DECK.default], skill: v.skill, totem: v.totem };
  } catch { /* private mode, or junk */ }
  return { deck: [...DECK.default], skill: SKILL_PICK.default, totem: 'wind' };
}

export function keepLoadout(l: Loadout) {
  try { localStorage.setItem(KEY, JSON.stringify(l)); } catch { /* not kept: the defaults next time */ }
}
